// Resume46.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

const Resume46 = ({ color = "#e35cc4" }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '210mm',          // A4
          minHeight: '297mm',
          bgcolor: 'white',
          p: 6,
          pt: 8,
          pb: 8,
          fontFamily: "'Georgia', 'Times New Roman', serif",
          color: '#1a1a1a',
        }}
      >
        {/* Name & Title */}
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              letterSpacing: '3px',
              color: color,
              fontSize: '2.8rem',
              lineHeight: 1.1,
              mb: 1,
            }}
          >
            OLIVIA WILSON
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: color,
              letterSpacing: '1.5px',
              fontSize: '1.35rem',
              textTransform: 'uppercase',
            }}
          >
            Marketing Manager
          </Typography>

          <Box sx={{ mt: 2, fontSize: '1rem', color: '#444' }}>
            123 Anywhere St., Any City, ST12345<br />
            123-456-7890  •  hello@reallygreatsite.com
          </Box>
        </Box>

        <Divider sx={{ borderColor: color, borderWidth: 1, my: 4 }} />

        {/* Career Objective */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 1.5,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Career Objective
          </Typography>
          <Typography sx={{ lineHeight: 1.8, fontSize: '0.98rem' }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </Typography>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* Work Experience */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 2,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Work Experience
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <Typography sx={{ fontWeight: 700, color: color, fontSize: '1.1rem' }}>
                Marketing Manager
              </Typography>
              <Typography sx={{ fontStyle: 'italic', color: '#555' }}>
                2016 – 2020
              </Typography>
            </Box>
            <Typography sx={{ fontWeight: 600, color: '#333', mb: 1 }}>
              Ginyard International Co.
            </Typography>
            <Typography component="ul" sx={{ pl: 3, lineHeight: 1.9, fontSize: '0.97rem' }}>
              <li>Developed new promotional campaign by bundling products together for Cosmetic business, increasing sales revenue by 24%</li>
              <li>Established new social media team including Web developers, and Creative Designer growing company web presence and global brand awareness by 45%</li>
            </Typography>
          </Box>

          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <Typography sx={{ fontWeight: 700, color: color, fontSize: '1.1rem' }}>
                Business Consultant
              </Typography>
              <Typography sx={{ fontStyle: 'italic', color: '#555' }}>
                2014 – 2015
              </Typography>
            </Box>
            <Typography sx={{ fontWeight: 600, color: '#333', mb: 1 }}>
              Wardiere Inc.
            </Typography>
            <Typography sx={{ lineHeight: 1.8, fontSize: '0.97rem' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* Education */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 2,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Education
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <Typography sx={{ fontWeight: 700, color: color }}>
                Master of Science in Marketing
              </Typography>
              <Typography sx={{ fontStyle: 'italic', color: '#555' }}>
                3.85/4 GPA
              </Typography>
            </Box>
            <Typography sx={{ fontWeight: 600, color: '#333' }}>
              Fauget University
            </Typography>
            <Typography sx={{ color: '#555', fontStyle: 'italic' }}>
              2004 – 2008
            </Typography>
          </Box>

          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <Typography sx={{ fontWeight: 700, color: color }}>
                Bachelor of Science in Marketing
              </Typography>
              <Typography sx={{ fontStyle: 'italic', color: '#555' }}>
                3.7/4 GPA
              </Typography>
            </Box>
            <Typography sx={{ fontWeight: 600, color: '#333' }}>
              Borcelle University
            </Typography>
            <Typography sx={{ color: '#555', fontStyle: 'italic' }}>
              2008 – 2011
            </Typography>
          </Box>
        </Box>

      

     
      </Paper>
    </Box>
  );
};

export const resumeMeta = {
  hasPhoto: false,
  columns: 1,
  colorOptions: [
    { value: "#e35cc4", label: "Vivid Pink" },
    { value: "#00695c", label: "Deep Teal" },
    { value: "#d84315", label: "Fiery Orange" },
    { value: "#5d4037", label: "Warm Brown" },
    { value: "#0277bd", label: "Strong Blue" }
  ]
};

export default Resume46;